import type { DraftTask } from '@dyspatch/core';
import { Empty } from '@/components/common/bits';
import { JobGraph } from '@/features/graph/JobGraph';

/**
 * A schedule's template plan, drawn as the graph every other plan is drawn as.
 *
 * The nodes are `DraftTask`s that have never run: a key, a title, a repo and
 * the steps they wait on, and no id, status, device or pull request. `JobGraph`
 * draws what a node has, so the same component that draws a live job draws this
 * one in its plan phase, with no flag saying which. No handler is passed, so the
 * nodes are boxes rather than a row of dead tab stops.
 *
 * Every run of this schedule turns these nodes into real task rows, and the
 * graph on that job's own page is this picture with the live state filled in.
 * Drawing them the same way is the point: a person approving a template is
 * looking at the shape they will be reading every morning after.
 */
export function TemplatePlan({ tasks }: { tasks: readonly DraftTask[] }) {
  if (!tasks.length) return <Empty>This schedule has no tasks, which cannot happen.</Empty>;

  return <JobGraph tasks={tasks} />;
}
